<div class="row" class="row mb-3">
    <div class="col-12 col-sm-2">
        <h6 class="text-primary">Accession Number</h6>
        <p style="font-size: large; font-weight: 500; margin: 0;"><span style="color:#6992af !important;">
                <i *ngIf="item.ItemType == 'package'" class="fa fa-box-archive" pTooltip="Package Properties"></i>
                <i *ngIf="item.ItemType === 'doc'" class="fa fa-file-lines" pTooltip="Document Properties"></i>
            </span> {{item.AccessionNumber}}</p>
    </div>
    <div class="col-12 col-sm-9">
        <h6 class="text-primary">Document Title</h6>
        <p style="font-size: large; font-weight: 500; margin: 0;">
             <i *ngIf="item.POFStatus === constants.POFLockStatusLocked" class="fa fa-lock"
              pTooltip="Protected Order File - Locked" tooltipPosition="left"></i>  
            <i *ngIf="item.POFStatus === constants.POFLockStatusUnlocked" class="fa fa-lock-open"
          pTooltip="Protected Order File - Unlocked" tooltipPosition="left"></i> {{item.DocumentTitle}}</p>
    </div>
</div>
<div class="row mb-3">
    <div class="col-11" *ngIf="item.ItemType == 'package'">
        <span class="me-3">
            <p-splitButton label="Package Properties" icon="fa-regular fa-share-from-square" [model]="shareDocPropItems"
                pTooltip="Share Package Properties" styleClass="p-button-primary p-button-sm me-2"
                id=""></p-splitButton>
        </span>
        <span class="me-3">
            <p-splitButton label="Go to Folder" icon="fa-regular fa-folder" [model]="goToFolderItems"
                pTooltip="Go to Folder" styleClass="p-button-primary p-button-sm me-2" id=""></p-splitButton>
        </span>
    </div>
    <div class="col-11" *ngIf="item.ItemType === 'doc'">
        <span class="me-3">
            <p-splitButton label="Document Properties" icon="fa-regular fa-share-from-square"
                [model]="shareDocPropItems" pTooltip="Share Document Properties"
                styleClass="p-button-primary p-button-sm me-2" id=""></p-splitButton>
        </span>
        <span *ngIf="item.POFStatus != constants.POFLockStatusLocked" class="me-3">
            <p-splitButton label="Document" icon="fa-regular fa-share-from-square" [model]="shareDocItems"
                pTooltip="Share/Download Document" styleClass="p-button-primary p-button-sm me-2" id=""></p-splitButton>
        </span>
        <span class="me">
            <p-splitButton label="Go to Folder" icon="fa-regular fa-folder" [model]="goToFolderItems"
                pTooltip="Go to Folder" styleClass="p-button-primary p-button-sm me-2" id=""></p-splitButton>
        </span>
    </div>
</div>

<table id="docProperties">
    <tr *ngIf="item.PackageNumber && item.PackageNumber.toString()">
        <td class="text-primary">Package Number</td>
        <td>{{item.PackageNumber}}</td>
    </tr>
    <tr *ngIf="item.PackagesFiledIn && item.PackagesFiledIn.toString()">
        <td class="text-primary">Parent Documents</td>
        <td>{{item.PackagesFiledIn}}</td>
    </tr>
     <tr *ngIf="item.ItemType == 'package' && item.DocumentsFiledInPackage">
        <td class="text-primary">Documents Filed In Package</td>
        <td>{{item.DocumentsFiledInPackage | addSpaceAfterComma}}</td>
    </tr>
    <tr *ngIf="item.AuthorName && item.AuthorName.toString()">
        <td class="text-primary">Author(s)</td>
        <td>{{item.AuthorName}}</td>
    </tr>
    <tr *ngIf="item.AuthorAffiliation && item.AuthorAffiliation.toString()">
        <td class="text-primary">Author Affiliation</td>
        <td>{{item.AuthorAffiliation}}</td>
    </tr>
    <tr *ngIf="item.AddresseeName && item.AddresseeName.toString()">
        <td class="text-primary">Addressee Name</td>
        <td>{{item.AddresseeName}}</td>
    </tr>
    <tr *ngIf="item.AddresseeAffiliation && item.AddresseeAffiliation.toString()">
        <td class="text-primary">Addresee Affiliation</td>
        <td>{{item.AddresseeAffiliation}}</td>
    </tr>
    <tr *ngIf="item.CaseReferenceNumber && item.CaseReferenceNumber.toString()">
        <td class="text-primary">Case Reference Number</td>
        <td>{{item.CaseReferenceNumber}}</td>
    </tr>
    <tr *ngIf="item.LicenseNumber && item.LicenseNumber.toString()">
        <td class="text-primary">License Number</td>
        <td>{{item.LicenseNumber}}</td>
    </tr>
    <tr *ngIf="item.DateAdded && item.DateAdded.toString()">
        <td class="text-primary">Date Added</td>
        <td>{{item.DateAdded | date}}</td>
    </tr>
    <tr *ngIf="item.DocumentDate && item.DocumentDate.toString()">
        <td class="text-primary">Document Date</td>
        <td>{{item.DocumentDate | date}}</td>
    </tr>
    <tr *ngIf="item.DocumentType && item.DocumentType.toString()">
        <td class="text-primary">Document Type</td>
        <td>
            <span *ngFor="let i of item.DocumentType">
                {{i}}<br />
            </span>
        </td>
    </tr>
    <tr *ngIf="item.DocumentReportNumber && item.DocumentReportNumber.toString()">
        <td class="text-primary">Document Report Number</td>
        <td>{{item.DocumentReportNumber}}</td>
    </tr>
    <tr *ngIf="item.DocketNumber && item.DocketNumber.toString()">
        <td class="text-primary">Docket Number</td>
        <td>{{item.DocketNumber}}</td>
    </tr>
    <tr *ngIf="item.DateDocketed">
        <td class="text-primary">Date Docketed</td>
        <td>{{item.DateDocketed | date}}</td>
    </tr>
    <tr *ngIf="item.Comment && item.Comment.toString()">
        <td class="text-primary">Comment</td>
        <td>{{item.Comment}}</td>
    </tr>
   
    <tr *ngIf="item.DistributionListCodes">
        <td class="text-primary">Distribution List Codes</td>
        <td>{{item.DistributionListCodes}}</td>
    </tr>
    <tr *ngIf="item.ContactPerson && item.ContactPerson.toString()">
        <td class="text-primary">Contact Person</td>
        <td>{{item.ContactPerson}}</td>
    </tr>

    <tr *ngIf="item.ASLBPNumber">
        <td class="text-primary">ASLBP Number</td>
        <td>{{item.ASLBPNumber}}</td>
    </tr>
    <tr *ngIf="item.Availability">
        <td class="text-primary">Availability</td>
        <td>{{item.Availability}}</td>
    </tr>
    <tr *ngIf="item.CUIDocumentSensitivity && item.CUIDocumentSensitivity.toString()">
        <td class="text-primary">CUI Document Sensitivity</td>
        <td>{{item.CUIDocumentSensitivity}}</td>
    </tr>

    <tr *ngIf="item.DatetobeReleased">
        <td class="text-primary">Date To Be Released</td>
        <td>{{item.DatetobeReleased | date}}</td>
    </tr>

    <tr *ngIf="item.DocumentDateReceived">
        <td class="text-primary">Document Date Received</td>
        <td>{{item.DocumentDateReceived | date}}</td>
    </tr>
    <tr *ngIf="item.DocumentStatus">
        <td class="text-primary">Document Status</td>
        <td>{{item.DocumentStatus}}</td>
    </tr>
    <tr *ngIf="item.ExhibitStatus">
        <td class="text-primary">Exhibit Status</td>
        <td>{{item.ExhibitStatus}}</td>
    </tr>
    <tr *ngIf="item.FACADocument">
        <td class="text-primary">FACA Document</td>
        <td>{{item.FACADocument}}</td>
    </tr>
    <tr *ngIf="item.ProceedingsFiledIn && item.ProceedingsFiledIn.toString()">
        <td class="text-primary">Proceedings Filed In</td>
        <td>
            <span *ngFor="let i of item.ProceedingsFiledIn">
                {{i}}<br />
            </span>
        </td>
    </tr>
    <tr *ngIf="item.FoldersFiledIn && item.FoldersFiledIn.toString()">
        <td class="text-primary">Folders Filed In</td>
        <td>
            <span *ngFor="let i of item.FoldersFiledIn">
                {{i}}<br />
            </span>
        </td>
    </tr>
    <tr *ngIf="item.HearingOfficialExhibitNumber">
        <td class="text-primary">Hearing Official Exhibit Number</td>
        <td>{{item.HearingOfficialExhibitNumber}}</td>
    </tr>
    <tr *ngIf="item.HearingPartyExhibitNumber">
        <td class="text-primary">Hearing Party Exhibit Number</td>
        <td>{{item.HearingPartyExhibitNumber}}</td>
    </tr>
    <tr *ngIf="item.HearingPartyIdentifier">
        <td class="text-primary">Hearing Party Identifier</td>
        <td>{{item.HearingPartyIdentifier}}</td>
    </tr>
    <tr *ngIf="item.OfficialRecord">
        <td class="text-primary">Official Record</td>
        <td>{{item.OfficialRecord}}</td>
    </tr>
    <!-- <tr *ngIf="item.PublishStatusEHD">
        <td class="text-primary">Publish Status EHD</td>
        <td>{{item.PublishStatusEHD}}</td>
    </tr>
    <tr *ngIf="item.PublishStatusOGC">
        <td class="text-primary">Publish Status OGC</td>
        <td>{{item.PublishStatusOGC}}</td>
    </tr>
    <tr *ngIf="item.PublishStatusPARS">
        <td class="text-primary">Publish Status PARS</td>
        <td>{{item.PublishStatusPARS}}</td>
    </tr> -->
    <tr *ngIf="item.PublishedtoEHDDate">
        <td class="text-primary">Published To EHD Date</td>
        <td>{{item.PublishedtoEHDDate | date}}</td>
    </tr>
    <tr *ngIf="item.RelatedDate">
        <td class="text-primary">Related Date</td>
        <td>{{item.RelatedDate | date}}</td>
    </tr>
    <tr *ngIf="item.Replicated">
        <td class="text-primary">Replicated</td>
        <td>{{item.Replicated}}</td>
    </tr>
    <tr *ngIf="item.TextSourceFlag">
        <td class="text-primary">Text Source Flag</td>
        <td>{{item.TextSourceFlag}}</td>
    </tr>
    <tr *ngIf="item.VitalRecordsCategory">
        <td class="text-primary">Vital Records Category</td>
        <td>{{item.VitalRecordsCategory}}</td>
    </tr>
   
    <tr *ngIf="item.Keyword && item.Keyword.toString()">
        <td class="text-primary">Keyword</td>
        <td>{{item.Keyword}}</td>
    </tr>
</table>
<p-toast position="bottom-right"></p-toast>